<div class="login_page-container">
  <main class="body">
    <div class="img_container"></div>
    <div class="login_container">
      <div class="login_logo">
        <img src="assets/img-login.png" alt="Logo" class="login_logo-img" loading="lazy" />
      </div>
      <div class="login_title">
        <h1 class="login_text-titulo">Gestión de Campos</h1>
        <h1 class="login_text-usuario">
          {{ usuarioTipo }}
        </h1>
      </div>
      <div class="login_form-container">
        <form action="" class="login_form" [formGroup]="validateForm" (ngSubmit)="submitForm()">
          <!--Usuario-->
          <div class="login_form-item">
              <input type="text" class="login_form-control" placeholder="Usuario" formControlName="userName" />
          </div>
          <!--Contraseña-->
          <div class="login_form-item">
              <input type="password" class="login_form-control" placeholder="Contraseña" formControlName="password" />
          </div>

          <!-- Mostrar el mensaje de error si existe -->
          <div *ngIf="errorMessage" class="error-message" style="color: red">
            {{ errorMessage }}
          </div>
          <!--Botón de Ingresar-->
          <button type="submit" class="login_form-button">Iniciar sesión</button>
        </form>
      </div>
    </div>
  </main>
</div>
